/**
 * @param number
 * @param precision
 * @param options
 * @param options.dontRoundNextPrecision
 * @returns {string}
 */
export default function toFixedNumberUtil (number, precision, options) {
  const factor = Math.pow(10, precision)

  let num
  if (options?.dontRoundNextPrecision) {
    num = Math.floor(number * factor) / factor
  } else {
    num = Math.round(number * factor) / factor
  }

  return num.toFixed(precision)
}
